import { render, staticRenderFns } from "./ponchado.vue?vue&type=template&id=b395ccdc"
import script from "./ponchado.vue?vue&type=script&lang=js"
export * from "./ponchado.vue?vue&type=script&lang=js"
import style0 from "./ponchado.vue?vue&type=style&index=0&id=b395ccdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports